export default __webpack_public_path__ + "static/media/user-check.f1bced60.svg";